//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'browser',
  data: function () {
    return {
      detectedApp: '系统相机 / 浏览器'
    }
  },
  mounted: function () {
    var ua = window.navigator.userAgent || ''
    if (/AlipayClient/i.test(ua)) {
      this.detectedApp = '支付宝'
    } else if (/QQ\/|MQQBrowser/i.test(ua)) {
      this.detectedApp = 'QQ'
    } else if (/Quark/i.test(ua)) {
      this.detectedApp = '夸克浏览器'
    } else if (/UCBrowser|UCWEB/i.test(ua)) {
      this.detectedApp = 'UC浏览器'
    } else if (/baiduboxapp|BaiduHost/i.test(ua)) {
      this.detectedApp = '百度'
    } else if (/aweme|Bytedance|douyin|ByteLocale/i.test(ua)) {
      this.detectedApp = '抖音'
    } else if (/DingTalk/i.test(ua)) {
      this.detectedApp = '钉钉'
    } else if (/MicroMessenger/i.test(ua)) {
      this.detectedApp = '微信'
    } else if (/VivoBrowser|HeyTapBrowser|HUAWEIBrowser|MiuiBrowser|HONOR/i.test(ua)) {
      this.detectedApp = '手机自带浏览器'
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/miniUrl/browser.vue